export const DIRECTORY_FIELDS_SYSTEMS = {
  google: 'Google',
  office365: 'Microsoft 365',
  salesforce: 'Salesforce',
  surefire: 'Surefire CRM',
  totalexpert: 'TotalExpert',
  customdir: 'label.CUSTOM_DIRECTORY',
  airtable: 'Airtable',
  bamboohr: 'BambooHR',
  frontapp: 'Front',
  paylocity: 'Paylocity',
  pingboard: 'PingBoard',
  okta: 'Okta',
  onelogin: 'OneLogin',
  outreach: 'Outreach',
  csv: 'CSV',
  params: 'label.PARAMS',
  mangoapps: 'label.MANGOAPPS',
  calendlydata: 'Calendly',
  ukg: 'UKG'
};

export const DIRECTORY_FIELDS_DEFAULTS = {
  microsoft: [
    { system: 'office365', source: 'displayName', dest: 'name', forceoverride: false, transforms: [] },
    { system: 'office365', source: 'givenName', dest: 'firstname', forceoverride: false, transforms: [] },
    { system: 'office365', source: 'surname', dest: 'lastname', forceoverride: false, transforms: [] },
    { system: 'office365', source: 'jobTitle', dest: 'title', forceoverride: false, transforms: [] },
    { system: 'office365', source: 'telephoneNumber', dest: 'phone', forceoverride: false, transforms: [] },
    { system: 'office365', source: 'mobile', dest: 'mobile', forceoverride: false, transforms: [] },
    { system: 'office365', source: 'mail', dest: 'email', forceoverride: false, transforms: [] },
    { system: 'office365', source: 'facsimileTelephoneNumber', dest: 'fax', forceoverride: false, transforms: [] },
    { system: 'office365', source: 'streetAddress', dest: 'street', forceoverride: false, transforms: [] },
    { system: 'office365', source: 'city', dest: 'city', forceoverride: false, transforms: [] },
    { system: 'office365', source: 'state', dest: 'state', forceoverride: false, transforms: [] },
    { system: 'office365', source: 'postalCode', dest: 'postalcode', forceoverride: false, transforms: [] },
    { system: 'office365', source: 'department', dest: 'department', forceoverride: false, transforms: [] }
  ],
  google: [
    { system: 'google', source: 'fullName', dest: 'name', forceoverride: false, transforms: [] },
    { system: 'google', source: 'givenName', dest: 'firstname', forceoverride: false, transforms: [] },
    { system: 'google', source: 'familyName', dest: 'lastname', forceoverride: false, transforms: [] },
    { system: 'google', source: 'title', dest: 'title', forceoverride: false, transforms: [] },
    { system: 'google', source: 'telephoneNumber', dest: 'phone', forceoverride: false, transforms: [] },
    { system: 'google', source: 'mobile', dest: 'mobile', forceoverride: false, transforms: [] },
    { system: 'google', source: 'primaryEmail', dest: 'email', forceoverride: false, transforms: [] },
    { system: 'google', source: 'department', dest: 'department', forceoverride: false, transforms: [] },
    { system: 'google', source: 'formatted', dest: 'address', forceoverride: false, transforms: [] },
    { system: 'google', source: 'city', dest: 'city', forceoverride: false, transforms: [] },
    { system: 'google', source: 'state', dest: 'state', forceoverride: false, transforms: [] },
    { system: 'google', source: 'country', dest: 'country', forceoverride: false, transforms: [] },
    { system: 'google', source: 'postcode', dest: 'postalcode', forceoverride: false, transforms: [] }
  ],
  bamboo: [
    { system: 'bamboohr', source: 'displayName', dest: 'name', forceoverride: false, transforms: [] },
    { system: 'bamboohr', source: 'firstName', dest: 'firstname', forceoverride: false, transforms: [] },
    { system: 'bamboohr', source: 'lastName', dest: 'lastname', forceoverride: false, transforms: [] },
    { system: 'bamboohr', source: 'jobTitle', dest: 'title', forceoverride: false, transforms: [] },
    { system: 'bamboohr', source: 'workPhone', dest: 'phone', forceoverride: false, transforms: [] },
    { system: 'bamboohr', source: 'mobilePhone', dest: 'mobile', forceoverride: false, transforms: [] },
    { system: 'bamboohr', source: 'workEmail', dest: 'email', forceoverride: false, transforms: [] },
    { system: 'bamboohr', source: 'department', dest: 'department', forceoverride: false, transforms: [] },
    { system: 'bamboohr', source: 'location', dest: 'location', forceoverride: false, transforms: [] }
  ]
};

export const VCARD_FIELDS_DEFAULTS = [
  { field: 'firstName', value: 'fields.name' },
  { field: 'title', value: 'fields.title' },
  { field: 'workEmail', value: 'fields.email' },
  { field: 'workPhone', value: 'fields.phone' },
  { field: 'cellPhone', value: 'fields.mobile' },
  { field: 'organization', value: "'COMPANY_NAME_HERE'" },
  { field: 'photoUrlPng', value: 'https://smart.COMPANY_DOMAIN/photo/{{email}}/PLATFORM.jpg' }
];
